export default __webpack_public_path__ + "static/media/pkg.85bd910d.svg";